interface ISaveBlobAsFileProps {
  blob: Blob;
  fileName: string;
}

// NOTE: Triggers browser download dialog by creating a temporary anchor element.
export const saveBlobAsFile = ({
  blob,
  fileName,
}: ISaveBlobAsFileProps): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
